import { SelectionModel } from "@angular/cdk/collections";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TableComponent } from "src/app/table.component";
import { Helpers } from "src/helpers/helpers";
import { ReportService } from "src/services/report.service";
import { CareplusRequestsService } from "src/services/careplus-requests.service";
import { CareplusPolicy } from "src/models/careplus-policy";
import { CareplusPolicyStatus } from "src/models/careplus.constants";
import { FeeDetails } from "src/models/fee-details";
import { CareplusMember } from "src/models/careplus-member";
import { MAT_DATE_FORMATS } from "@angular/material/core";

export const DATE_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY",
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
export class Customer {
  id: number;
  customerName: string;
  userName: string;
  requestType: string;
  vehicleType: string;
  date: string;
  amount: string;
  status: string;
}

@Component({
  selector: "app-careplus-requests",
  templateUrl: "./careplus-requests.component.html",
  styleUrls: ["./careplus-requests.component.css"],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }],
})
export class CareplusRequestsComponent
  extends TableComponent<CareplusPolicy>
  implements OnInit
{
  pageTitle = "Request";
  error: any;
  displayedColumns: string[] = [
    "id",
    "createdAt",
    "status",
    "policyUpdateAction",
    "ownerName",
    "email",
    "phoneNumber",
    "policyNumber",
    "policyStartDate",
    "policyEndDate",
    "totalMembers",
    "basePremium",
    "totalFees",
    "totalDueAmount",
    "discountAmount",
    "amountPaid",
    "promotionName",
    "couponCode",
    "paymentId",
    "paymentToken",
    "source",
    "referrerName",
    "insurer",
  ];
  selection = new SelectionModel<any>(true, []);
  status: string = "all";
  search: string = "";
  issueDateFrom?: string;
  issueDateTo?: string;
  forAgency: boolean = false;
  feeDetails?: FeeDetails;
  CareplusPolicyStatus = CareplusPolicyStatus;

  constructor(
    public requestService: CareplusRequestsService,
    private _reportService: ReportService,
    private router: Router,
    private helper: Helpers,
  ) {
    super(requestService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.requestService.getFeeDetails().subscribe({
      next: (feeDetails) => {
        this.feeDetails = feeDetails;
      },
    });
  }

  openPurchaseDetail(policy: CareplusPolicy): void {
    if (policy.transactionStatus != CareplusPolicyStatus.PAYMENT_PENDING) {
      this.router.navigate(["/careplus-orders/" + policy.id], {
        state: {
          policy: policy,
          isCareplusReq: true,
        },
      });
    }
  }

  onSubmit(): void {
    this.getCount().subscribe((res) => {
      this.count = res.count;
      this.loadRequests();
    });
  }

  clearFilters(): void {
    this.search = "";
    this.status = "all";
    this.issueDateFrom = undefined;
    this.issueDateTo = undefined;
    this.onSubmit();
  }

  getCount() {
    const { endDate } = this.getDateRange();

    return this.countService.getCount({
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
    });
  }

  getData() {
    const { endDate } = this.getDateRange();
    let pageSize = this.paginator.pageSize ? this.paginator.pageSize : 10;
    return {
      skip: this.paginator.pageIndex * pageSize,
      take: pageSize,
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
      orderBy: this.sort.active,
      orderByDescending: this.sort.direction === "desc",
    };
  }

  downloadReport(isXLS: boolean) {
    const { endDate } = this.getDateRange();

    const data = {
      filter: this.search ?? "",
      statuses: this.status === "all" || !this.status ? [] : [this.status],
      startDate: this.issueDateFrom
        ? new Date(this.issueDateFrom).toISOString()
        : undefined,
      endDate,
    };
    this._reportService.downloadReport("DownloadCarePlusRequestsReport", data);
  }

  prepareIssuePayload() {
    return {
      contributorFee: this.feeDetails?.contributorFee ?? 0,
      beneficiaryFee: this.feeDetails?.beneficiaryFee ?? 0,
      supervisionFee: this.feeDetails?.supervisionFee ?? 0,
    };
  }

  onClickStatusButton(element: any, event: Event) {
    event.stopPropagation();

    const issuePolicyObject = this.prepareIssuePayload();
    if (element.transactionStatus === CareplusPolicyStatus.PAID) {
      this.requestService
        .issuePolicy(element.id, issuePolicyObject)
        .subscribe();
    } else if (element.transactionStatus === CareplusPolicyStatus.BTIC_ISSUED) {
      this.requestService
        .generateDocuments(element.id)
        .subscribe(() => this.loadRequests());
    } else {
      this.requestService.resendEmail(element.id).subscribe();
    }
  }

  private getDateRange() {
    let endDate;

    if (this.issueDateTo) {
      const end = new Date(this.issueDateTo);

      endDate = new Date(
        Date.UTC(
          end.getFullYear(),
          end.getMonth(),
          end.getDate(),
          23,
          59,
          59,
          999,
        ),
      ).toISOString();
    }

    return { endDate };
  }
}
